/**
 * @generated SignedSource<<5176f9bcfda06674b5bb59ecc0653f3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpExhibitionNoteVideo_note$data = {
  readonly caption: string | null;
  readonly embedCode: string | null;
  readonly " $fragmentType": "NftPdpExhibitionNoteVideo_note";
};
export type NftPdpExhibitionNoteVideo_note$key = {
  readonly " $data"?: NftPdpExhibitionNoteVideo_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpExhibitionNoteVideo_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpExhibitionNoteVideo_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "embedCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caption",
      "storageKey": null
    }
  ],
  "type": "NftExhibitionNoteVideoEmbedContent",
  "abstractKey": null
};

(node as any).hash = "cd18d6796a2ee421cc6cc62e6a922472";

export default node;
